<template lang="pug">

  form-group-row(v-if='states', :form='form', :label="label", name="state")
    v-select.form-control(v-if="unitedStates" v-model="state", label="value", :options="states", :searchable="true", :class="{'is-invalid': form.errors.has('state')}")
    form-input(v-else="" :form="form", name="state")

</template>

<script>

import { UsaStates } from 'usa-states';

export default {
  name: 'user-input-state',

  props: {
    label: {
      type: String,
      default: 'State',
    }
  },

  data: () => ({
    form: null,
    state: null,
    states: null,
    unitedStates: null,
  }),

  watch: {
    state(val) {
      this.form.state = val ? val.value : null;
    },
    'form.country': function(val) {
      this.unitedStates = val == 'United States';
    }
  },

  created() {
    this.form = this.$parent.form;
    this.state = this.$parent.user && this.$parent.user.meta.state ? { value: this.$parent.user.meta.state } : null;
    this.form.state = this.state ? this.state.value : null;
    this.states = (new UsaStates()).states.map(x => ({value: x.name}));
  },
}

</script>
